import { render, staticRenderFns } from "./settlementAct.vue?vue&type=template&id=40db8283&scoped=true"
import script from "./settlementAct.vue?vue&type=script&lang=js"
export * from "./settlementAct.vue?vue&type=script&lang=js"
import style0 from "./settlementAct.vue?vue&type=style&index=0&id=40db8283&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40db8283",
  null
  
)

export default component.exports